import styles from "../../styles/PLMApp.module.css";
// src/components/plm/WorkflowBoard.jsx

import { PLM_CATEGORIES } from "../../data/constants";
import CategoryRow from "./CategoryRow";

export default function WorkflowBoard({
  steps,
  onOpenStep,
  onStatusChange,
  supplierId,
  statusDisabled = false,
  isAdmin,
}) {
  return (
    <div className={styles.workflowBoard}>
      {PLM_CATEGORIES.map((cat, i) => (
        <CategoryRow
          key={cat.id}
          category={cat}
          catIndex={i}
          steps={steps}
          onOpenStep={onOpenStep}
          onStatusChange={onStatusChange}
          supplierId={supplierId}
          statusDisabled={statusDisabled}
          isAdmin={isAdmin}
        />
      ))}
    </div>
  );
}
